import * as React from "react";
import {
  CartProvider,
  ShopifyProvider,
  useShop,
} from "@shopify/hydrogen-react";
import { constants } from "config";

// TODO: Add mixpanel events to on* event props for CartProvider?
// onLineAddComplete
// onLineRemoveComplete
// onBuyerIdentityUpdate
function ShopProvider({ children }: { children: React.ReactNode }) {
  return (
    <ShopifyProvider
      countryIsoCode="US"
      languageIsoCode="EN"
      storeDomain={constants.shopifyDomain}
      storefrontToken={constants.shopifyAccessToken}
      // NOTE: this has to match the installed @shopify/hydrogen-react version
      storefrontApiVersion="2024-01"
    >
      <CartProvider>{children}</CartProvider>
    </ShopifyProvider>
  );
}

export { ShopProvider, useShop };
